import React from "react";
import { Footer } from "./Footer/Footer";
import { Header } from "./Header/Header";
import { Main } from "../routers/Main.router";
import { Alert } from "../components/Alert/Alert";
import { useIdleLogout } from "../hooks/useIdleLogout";

export const MainLayout: React.FC = () => {
  const { showWarning, secondsLeft, stayLoggedIn } = useIdleLogout();

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <main>
          <section className="content-area">
            <div className="container">
              <Main />
            </div>
          </section>
        </main>
        <Footer />
      </div>
      <Alert
        show={showWarning}
        closeBtn={false}
        title="Session about to expire"
        errorMsg={`You have been inactive. You will be logged out in ${secondsLeft} seconds.`}
        acceptBtnTitle="Stay logged in"
        acceptBtnOnClick={stayLoggedIn}
      />
    </>
  );
};
